import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLayout({children}) {
    // Used in both Legals and Privacy screens to frame
    // content in both tablet and desktop modes

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div id={"glossary-layout"}
             className={"overflow-auto bg-backgroundLight3 h-[100vh] grow flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}